/**
 * Application Constants
 * 
 * Uses environment variables for configuration.
 * Create a .env file in your project root with these variables.
 */

// App Configuration
export const APP_CONFIG = {
  NAME: import.meta.env.VITE_APP_NAME || 'Auqli Store',
  VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true',
  FALLBACK_URL: import.meta.env.VITE_MOBILE_APP_FALLBACK_URL || 'https://auqli.live',
} as const;

// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.staging.auqli.live',
  TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 30000, // 30 seconds
  RETRY_ATTEMPTS: 0,
} as const;

// Mobile App Configuration
const RAW_MOBILE_APP_SCHEME = import.meta.env.VITE_MOBILE_APP_SCHEME || 'auqlistaging://app.staging.auqli.live';
const NORMALIZED_MOBILE_APP_SCHEME = RAW_MOBILE_APP_SCHEME.includes('://')
  ? RAW_MOBILE_APP_SCHEME
  : `${RAW_MOBILE_APP_SCHEME}://`;

export const MOBILE_APP_CONFIG = {
  SCHEME: NORMALIZED_MOBILE_APP_SCHEME,
  APP_STORE: {
    IOS: import.meta.env.VITE_APP_STORE_IOS || 'https://apps.apple.com/us/app/auqli-live-video-shopping/id6744903818',
    ANDROID: import.meta.env.VITE_APP_STORE_ANDROID || 'https://play.google.com/store/apps/details?id=com.auqli.auqliapp',
  },
} as const;

// User Agent Patterns
export const USER_AGENT_PATTERNS = {
  MOBILE_DEVICES: /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i,
  IOS_DEVICES: /iphone|ipad|ipod/i,
  ANDROID_DEVICES: /android/i,
} as const;

// Feature Flags
export const FEATURE_FLAGS = {
  ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  DEBUG_LOGGING: import.meta.env.VITE_ENABLE_DEBUG_LOGGING === 'true',
} as const;
